"use client"
import { useEffect, useRef } from "react"
import { useLazyThirdParty } from "@/hooks/useLazyThirdParty"
import { useConsent } from "@/lib/consent"

interface MicrosoftClarityProps {
  nonce?: string
}

// Loads only after the visitor accepts Analytics in the cookie banner (src/lib/consent.ts), and then
// on their first interaction. Tells Clarity that consent was given (Clarity's consent API).
export function MicrosoftClarity({ nonce = '' }: MicrosoftClarityProps) {
  const loaded = useRef(false)
  const interacted = useLazyThirdParty()
  const allowed = useConsent("analytics")

  useEffect(() => {
    if (!interacted || !allowed) return
    if (loaded.current) return
    loaded.current = true

    type Clarity = ((...args: unknown[]) => void) & { q?: unknown[][] }
    const w = window as typeof window & { clarity?: Clarity }
    const clarity: Clarity =
      w.clarity ||
      Object.assign((...args: unknown[]) => {
        ;(clarity.q ||= []).push(args)
      }, {})
    w.clarity = clarity

    const script = document.createElement("script")
    script.async = true
    script.src = "https://www.clarity.ms/tag/wnh6b4hi38"
    if (nonce) script.nonce = nonce
    document.head.appendChild(script)
    clarity("consent")
  }, [nonce, interacted, allowed])

  return null
}
